<template>
  <div v-if="tags.length > 0"
       class="product-detail-tags"
  >
    <ym-tag class="product-detail-tag"
            round
            type="gray"
            :border="false"
            v-for="(item, index) in list"
            :key="index"
    >
      {{ item }}
    </ym-tag>
  </div>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';

  export default {
    name: 'ProductDetailTags',
    components: {
      'ym-tag': Tag,
    },
    props: {
      tags: {
        type: Array,
      },
    },
    computed: {
      list() {
        return this.tags.filter((item, index) => index < 4);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-tags {
    display: flex;
    overflow: hidden;
  }

  .product-detail-tag {
    margin-right: @size-small;
  }
</style>
